const itemCls = "vyjipz8qbs";
const linkCls = "vyjlfvyzph";
const headingCls = "vyjh1ruk10i";
const breadcrumbListCls = "vyjbep1igu";
const breadcrumbCls = "vyjb14gig7c";
const breadcrumbTextCls = "vyjb1tp765u";
const breadcrumbChevronCls = "vyjb1d9nyqj";
const descriptionCls = "vyjda3g59y";

export { breadcrumbChevronCls, breadcrumbCls, breadcrumbListCls, breadcrumbTextCls, descriptionCls, headingCls, itemCls, linkCls };
import "./atom.result-item.style.linaria.module.css";
//# sourceMappingURL=atom.result-item.style.js.map
